import { FC } from "react";
import { Box, Typography } from "@mui/material";

const CustomerInfoBar: FC<any> = ({ data }) => {
  console.log("data",data);
  return(
  <Box
    sx={{
      backgroundColor: "#E5F4F1",
      borderRadius: "5px",
      padding: "10px 16px",
      fontSize: "13px",
      color: "#555",
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    <Typography component="span" sx={{ fontSize: "13px" }}>
      Customer name: <b>{data?.customer?.name || "—"}</b>
    </Typography>
    <Typography component="span" sx={{ color: "#BBB" }}>
      •
    </Typography>
    <Typography component="span" sx={{ fontSize: "13px" }}>
      {data?.stage}: <b>02/06/2025</b>
    </Typography>
    <Typography component="span" sx={{ color: "#BBB" }}>
      •
    </Typography>
    <Typography component="span" sx={{ fontSize: "13px" }}>
      Serial No: <b>{data?.leadId}</b>
    </Typography>
    <Typography component="span" sx={{ color: "#BBB" }}>
      •
    </Typography>
    {/* <Typography component="span" sx={{ fontSize: "13px" }}>
      Contract: <b>001</b>
    </Typography> */}
  </Box>
);}

export default CustomerInfoBar;
